export enum roles {
  LIBRA_ADMIN = 'libra_admin',
  ACCOUNT_OWNER = 'account_owner',
  AUTONOMOUS = 'autonomous',
  NON_AUTONOMOUS = 'non-autonomous',
}
